import { render, staticRenderFns } from "./HotelDescriptionMainText.vue?vue&type=template&id=f49b1f66&"
import script from "./HotelDescriptionMainText.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelDescriptionMainText.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelDescriptionMainText.vue?vue&type=style&index=0&id=f49b1f66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports